// apps/web/src/showcase/ShowcaseNotice.tsx
// Minimal interaction guard for showcase mode (spec §6). Static shots never
// trigger this; it exists so order-mutating taps can't crash or fire network.
// The designed nudge (copy, CTA, styling) replaces the inner div in the
// preview-page pass — keep the trigger seam, swap the presentation.
import React, { useEffect, useState } from 'react'
import { isShowcase } from './showcase'

let notify: (() => void) | null = null

/** Call from any order-mutating entry point when isShowcase(). */
export function showShowcaseNotice(): void {
  notify?.()
}

export function ShowcaseNoticeHost(): React.ReactElement | null {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (!isShowcase()) return
    notify = () => setVisible(true)
    return () => { notify = null }
  }, [])
  if (!isShowcase() || !visible) return null
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Preview only"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.4)',
        zIndex: 9999,
      }}
      onClick={() => setVisible(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 480,
          background: 'var(--color-white, #fff)',
          color: 'var(--color-gray-900, #111)',
          padding: '24px 20px calc(20px + env(safe-area-inset-bottom, 0px))',
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          textAlign: 'center',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.15)',
          transform: 'translateY(0)',
          transition: 'transform 0.25s ease-out',
        }}
      >
        <p style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600 }}>
          This is a preview — your real app takes orders.
        </p>
        <p style={{ margin: '0 0 20px', fontSize: 15, color: 'var(--color-gray-600, #555)' }}>
          Like what you see? It can be live in about two weeks.
        </p>
        <a
          href="https://webeatery.app/contact"
          target="_top"
          rel="noreferrer"
          style={{
            display: 'inline-block',
            width: '100%',
            background: 'var(--color-brand-600)',
            color: 'var(--color-text-on-brand-600, #fff)',
            fontWeight: 600,
            fontSize: 16,
            padding: '14px 24px',
            borderRadius: 12,
            textDecoration: 'none',
            boxSizing: 'border-box',
          }}
        >
          Book a call
        </a>
        <p style={{ margin: '12px 0 0', fontSize: 13, color: 'var(--color-gray-500, #888)' }}>
          or just reply to my email
        </p>
      </div>
    </div>
  )
}
